/**
 * Переводы: английский.
 *
 * ⚠️ КЛЮЧИ ОБЯЗАНЫ СОВПАДАТЬ ВО ВСЕХ ЧЕТЫРЁХ ЯЗЫКАХ. Пропущенный ключ не
 * ломает сборку и не роняет игру — на экране просто появляется сам ключ
 * вида «menu.shop_sell», и заметить это можно только глазами и только на
 * том языке, на котором никто не играет. Проверка парности — в index.ts
 * этой папки.
 *
 * ⚠️ РАЗДЕЛЕНО ПО ЯЗЫКАМ, А НЕ ПО РАЗДЕЛАМ ИГРЫ. Раздел («меню», «снасть»)
 * при переводе не нужен: переводчик работает с одним языком целиком, а
 * править разом четыре языка приходится только при добавлении ключа — и
 * тогда четыре файла рядом удобнее, чем четыре места в файле на 1845 строк.
 */
import { ТОВАРЫ_EN } from './goods-en.js';
import { РЫБЫ_EN } from './species-north-en.js';
import { МИР_EN } from './species-world-en.js';

export const en: Record<string, string> = {
  'fish.unknown': 'Fish on hook',
  ...ТОВАРЫ_EN,
  ...РЫБЫ_EN,
  ...МИР_EN,
  'hud.anglers_online': 'Anglers online: {n}',
  'loader.ключ': 'Checking your ticket',
  'loader.база': 'Opening the logbook',
  'loader.движок': 'Unwinding the reel',
  'loader.сцена': 'Rigging the rod',
  'loader.локация': 'Walking to the water',
  'loader.берег': 'Picking a spot',
  'auth.subtitle': 'Sign in',
  'auth.tab_login': 'Sign in',
  'auth.tab_register': 'Register',
  'auth.name': 'Name',
  'auth.name_hold': 'What to call you on the water',
  'auth.name_hint': 'Other anglers will see this name',
  'auth.email': 'Email',
  'auth.email_hint': 'Nobody can see your email — it stays private',
  'auth.password': 'Password',
  'auth.pass_hint': 'Latin letters only, with at least one digit and one capital',
  'auth.password2': 'Repeat password',
  'auth.pass2_hint': 'Type it twice so a typo cannot lock you out',
  'auth.login_btn': 'Sign in',
  'auth.register_btn': 'Create account',
  'auth.pass_min': 'At least 6 characters',
  'set.terrain_range': 'Terrain distance',
  'set.terrain_range_hint': 'The strongest effect on frame time: terrain takes over half of it',
  'set.range_near': 'Near',
  'set.range_normal': 'Normal',
  'set.range_far': 'Far',
  'set.antialias': 'Anti-aliasing',
  'set.antialias_hint': 'Removes upscaling blocks and jagged edges; costs fill rate',
  'set.aa_off': 'Off',
  'set.aa_soft': 'Soft',
  'set.aa_full': 'Full',
  'set.render_scale': 'Render scale',
  'set.render_scale_hint': 'The strongest lever: lower is much faster but softer',
  'set.fish_distance': 'Shore fish distance',
  'set.fish_distance_hint': 'Fish beyond this line are not drawn',
  'set.vol_tackle': 'Tackle',
  'set.vol_steps': 'Footsteps',
  'set.zoom': 'Zoom',
  'set.zoom_hint': 'Narrows the view: objects appear larger',
  'set.lang': 'Language',
  'set.lang_ru': 'Русский',
  'set.lang_en': 'English',
  'set.lang_uk': 'Українська',
  'set.lang_es': 'Español',
  'lobby.settings': 'Settings',
  'lobby.min_level': 'Available from level {level}',
  'set.tab_sound': 'Sound',
  'set.tab_lang': 'Language',
  'set.tab_account': 'Account',
  'set.vol_music': 'Music',
  'set.vol_effects': 'Menu sounds',
  'set.vol_note': 'Volume is kept on this device and does not follow you to another.',
  'unit.kg': 'kg',
  'unit.cm': 'cm',
  'unit.m': 'm',
  'unit.g': 'g',
  'unit.mm': 'mm',
  'unit.coins': 'coins',
  // ── Снаряжение и магазин ──
  'slot.rod': 'Rod',
  'slot.reel': 'Reel',
  'slot.line': 'Line',
  'slot.lure': 'Lure',
  'menu.gear': 'Inventory',
  'menu.shop': 'Keepnet',
  'menu.shop_sell': 'Keepnet',
  'keepnet.open_hint': 'Keepnet — click to open',
  'keepnet.title': 'Keepnet',
  'keepnet.full_warn': 'Keepnet is full — head back to base',
  'menu.shop_buy': 'Tackle',
  'menu.level': 'Level',
  'menu.max_level': 'max',
  'menu.worn': 'equipped',
  'menu.owned': 'owned',
  'menu.need_level': 'requires level',
  'menu.slot_empty': 'Empty',
  'menu.keepnet_empty': 'Keepnet is empty — go catch something',
  'menu.sell': 'Sell',
  'menu.sell_all': 'Select all',
  'menu.sell_pick': 'Pick some fish',
  'menu.selling': 'Selling…',
  'hud.caught_xp': '+{xp} XP',
  'hud.catch_rejected': 'Catch not recorded',
  // ── Меню игры ──
  'menu.button': 'Menu',
  'menu.title': 'Menu',
  'menu.resume': 'Resume',
  'menu.locations': 'Locations',
  'menu.records': 'Records',
  'menu.mine': 'My catches',
  'menu.settings': 'Settings',
  'menu.controls': 'Controls',
  'menu.logout': 'Sign out',
  'menu.graphics': 'Video',
  'menu.sound': 'Audio',
  'menu.game': 'Game',
  'menu.quality': 'Quality',
  'menu.preset_low': 'Low',
  'menu.preset_medium': 'Medium',
  'menu.preset_high': 'High',
  'menu.preset_custom': 'settings changed manually',
  'menu.reset': 'Reset section',
  'menu.on': 'on',
  'menu.off': 'off',
  'menu.needs_reload': 'applies after restart',
  'menu.loading': 'Loading…',
  'menu.server_off': 'Server not responding',
  'menu.no_locations': 'No locations yet',
  'menu.no_catches': 'Nothing yet',
  'menu.need_login': 'Sign in required',
  'menu.you_are_here': 'you are here',
  'menu.ctl_move': 'Move',
  'menu.ctl_run': 'Run',
  'menu.ctl_jump': 'Jump',
  'menu.ctl_cast': 'Cast',
  'menu.ctl_reel': 'Reel in',
  'menu.ctl_menu': 'Menu',
  'ui.unit_ms': 'ms',
  'ui.unit_mps': 'm/s',
  'ui.unit_beaufort': 'bft',
  'ui.stat_line_reserve': 'LINE RSRV',
  'ui.stat_drag': 'DRAG',
  'ui.stat_reel': 'SPEED',
  'ui.make_on': 'Build ON',
  'ui.make_off': 'Build off',
  'ui.ready_to_cast': 'READY TO CAST',
  'state.has_edits': 'edits exist — click «Rebuild»',
  'state.world_built': 'world built',
  'state.rebuilding': 'rebuilding...',
  'rhumb.С': 'N',
  'rhumb.ССВ': 'NNE',
  'rhumb.СВ': 'NE',
  'rhumb.ВСВ': 'ENE',
  'rhumb.В': 'E',
  'rhumb.ВЮВ': 'ESE',
  'rhumb.ЮВ': 'SE',
  'rhumb.ЮЮВ': 'SSE',
  'rhumb.Ю': 'S',
  'rhumb.ЮЮЗ': 'SSW',
  'rhumb.ЮЗ': 'SW',
  'rhumb.ЗЮЗ': 'WSW',
  'rhumb.З': 'W',
  'rhumb.ЗСЗ': 'WNW',
  'rhumb.СЗ': 'NW',
  'rhumb.ССЗ': 'NNW',
  // ⚠️ ЗДЕСЬ СТОЯЛО «...ru,», И ЭТО ЛОМАЛО АНГЛИЙСКИЙ ЯЗЫК ЦЕЛИКОМ ВЫШЕ
  // ЭТОЙ СТРОКИ. Вставка русского словаря посреди английского перезаписывала
  // всё, что объявлено до неё: 147 ключей из 457 отдавали русский текст, в том
  // числе весь экран входа — «Вход в игру», «Почта», «Войти» вместо «Sign in»,
  // «Email», «Sign in». Настоящие английские переводы при этом лежали на своих
  // местах и просто не доходили до экрана.
  //
  // Заметить это было почти нельзя: сборка не падает, игра не падает, а видно
  // только тому, кто откроет её по-английски. Вскрылось при разделении файла
  // переводов — TypeScript спросил, откуда в английском файле взяться «ru».
  //
  // Обратно вставку возвращать не надо. Английский полон: все 457 ключей
  // объявлены здесь своими словами. Пропуски ловит missingKeys() в index.ts.
  'ui.title': 'InterFishing v.1.0',
  'ui.gen_brush': 'Brush Radius',
  'ui.gen_lift': 'Step per Click',
  'ui.sec_place': 'What to Place',
  'ui.btn_tree': 'Tree',
  'ui.btn_bush': 'Bush',
  'ui.btn_grass': 'Grass',
  'ui.btn_rock': 'Rock',
  'ui.btn_reed': 'Reed',
  'ui.btn_weed': 'Weed',
  'ui.btn_erase': 'Erase in Circle',
  'ui.btn_loadmap': 'Load Map',
  'ui.btn_savemap': 'Save Map',
  'ui.btn_sizeup': 'Size +',
  'ui.btn_sizedown': 'Size −',
  'ui.help_make':
    'Look at the ground — the yellow ring shows where the edit will apply.\n    <kbd>Q</kbd> lower · <kbd>E</kbd> higher · <kbd>Z</kbd> undo.\n    In build mode, <kbd>LMB</kbd> repeats the last action,\n    and casting is disabled.<br />\n    Edits and objects are saved with the world and survive\n    "Rebuild": they are stored in world coordinates, not chunks.',
  'ui.help_play':
    '<kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> walk · <kbd>Shift</kbd> run ·\n    <kbd>LMB</kbd> look around<br />\n    <b>Swing cast:</b> hold <kbd>LMB</kbd>, pull mouse <b>towards you</b>, then\n    <b>sharply away</b>.<br />\n    <b>Click cast:</b> hold <kbd>LMB</kbd> — ring gains power,\n    release — it flies. <b>Red</b> ring: too much power, will drop at your feet.<br />\n    On water, <kbd>LMB</kbd> — reel in.',
  'ui.unit_kg': 'kg',
  'ui.unit_cm': 'cm',
  'ui.unit_g': 'g',
  'ui.unit_m': 'm',
  'ui.unit_mm': 'mm',
  'ui.tab_world': 'World',
  'ui.tab_gen': 'Creator',
  'ui.tab_make': 'Build',
  'ui.btn_collapse': 'Collapse',
  'ui.stat_chunks': 'Chunks',
  'ui.stat_queue': 'In Queue',
  'ui.stat_gen': 'Generation',
  'ui.stat_tris': 'Triangles',
  'ui.stat_fps': 'FPS',
  'ui.stat_pos': 'Position',
  'ui.stat_alt': 'Altitude',
  'ui.stat_seed': 'Seed',
  'ui.ctl_zoom': 'Zoom',
  'ui.sec_weather': 'Sky & Weather',
  'ui.stat_sun': 'Sun',
  'ui.stat_sunrise': 'Sunrise',
  'ui.stat_sunset': 'Sunset',
  'ui.stat_daylen': 'Day Length',
  'ui.stat_vis': 'Visibility',
  'ui.stat_wind': 'Wind',
  'ui.stat_wave': 'Wave',
  'ui.ctl_time': 'Time',
  'ui.ctl_weather': 'Weather',
  'ui.val_clear': 'clear',
  'ui.ctl_force': 'Force',
  'ui.btn_clock': 'Clock Running',
  'ui.btn_wauto': 'Auto Weather',
  'ui.sec_tackle': 'Tackle',
  'ui.stat_cast': 'Cast',
  'ui.stat_tension': 'Tension',
  'ui.stat_horizon': 'Horizon',
  'ui.stat_depth': 'Depth',
  'ui.stat_tip': 'Tip',
  'ui.stat_fish': 'Fish',
  'ui.sec_lure': 'Lure',
  'ui.ctl_kind': 'Kind',
  'ui.val_spoon': 'spoon',
  'ui.ctl_weight': 'Weight',
  'ui.ctl_dive': 'Diving',
  'ui.ctl_bitex': 'Bite ×',
  'ui.sec_line': 'Line',
  'ui.ctl_mat': 'Material',
  'ui.val_mono': 'mono',
  'ui.ctl_dia': 'Diameter',
  'ui.stat_break': 'Breaking',
  'ui.sec_rod': 'Rod',
  'ui.ctl_class': 'Class',
  'ui.val_medium': 'medium',
  'ui.ctl_len': 'Length',
  'ui.ctl_test': 'Test',
  'ui.ctl_action': 'Action',
  'ui.val_mid': 'moderate',
  'ui.sec_rodpose': 'Rod Pose',
  'ui.btn_tune': 'Adjust',
  'ui.btn_std': 'Standard',
  'ui.btn_reset': 'Reset',
  'ui.btn_sizedn': 'Size −',
  'ui.stat_pose': 'Pose',
  'ui.sec_reelpose': 'Reel Pose',
  'ui.btn_setup': 'Setup',
  'ui.btn_save': 'Save',
  'ui.btn_mode_reel': 'Mode: Reel',
  'ui.sec_castmode': 'Cast Mode',
  'ui.btn_swing': 'Swing',
  'ui.btn_newline': 'New Line',
  'ui.btn_shore': 'To Shore',
  'ui.btn_newseed': 'New Seed',
  'ui.tr_caught': 'Caught',
  'ui.btn_ok': 'OK',
  'ui.language': 'Language',
  'state.high': 'too high above water — get closer to water',
  'state.reel_long': 'reeling in long slack',
  'state.click_water': 'clicked on water',
  'state.click': 'clicked',
  'state.no_swing': 'released without swing',
  'state.reel_hang': 'reeling: lure is hanging',
  'state.reel_water': 'reeling: lure is on water',
  'state.release': 'released',
  'state.line_end': 'ran out of line',
  'state.line_break': 'line broke at {kg} kg',
  'state.came_off': 'came off',
  'state.hooked_reel': 'hooked while reeling {kind}',
  'state.strike': 'strike {kind} {kg} kg',
  'state.strike_slack': 'strike on slack line',
  'state.hooked_auto': 'hooked itself {kind} {kg} kg',
  'state.spit': 'spit it out',
  'state.bite': 'bite {kind} {kg} kg',
  'state.attack': 'fish attack',
  'state.attack_school': 'school attack {kind} {kg} kg',
  'state.jump': 'jump',
  'state.lost_tear': 'tore lip — drag too tight',
  'state.lost_slack': 'lost on slack line',
  'state.lost_jump': 'shaken off during jump',
  'state.beached': 'fish beached',
  'state.landed': 'landed {kg} kg',
  'state.lost_why': 'lost: {why}',
  'state.lost_swing': 'lost during swing',
  'state.splash': 'splashdown',
  'state.reeled_slack': 'slack reeled in',
  'state.reset': 'tackle fully reset',
  'state.in_air': 'in air',
  'state.on_bottom': 'on bottom',
  'state.floating': 'floating',
  'state.in_water': 'in water',
  'hud.tab.world': 'WORLD',
  'hud.tab.generator': 'GENERATOR',
  'hud.tab.creator': 'CREATOR',
  'hud.sec.map': 'MAP',
  'hud.sec.sky': 'SKY & WEATHER',
  'hud.sec.tackle': 'TACKLE',
  'hud.sec.lure': 'LURE',
  'hud.sec.line': 'LINE',
  'hud.sec.rod': 'ROD',
  'hud.sec.rodPose': 'ROD POSE',
  'hud.sec.reelPose': 'REEL POSE',
  'map.chunks': 'Chunks',
  'map.generation': 'Generation',
  'map.frame': 'Frame',
  'map.height': 'Height',
  'map.seed': 'Seed',
  'map.position': 'Position',
  'map.scale': 'Scale',
  'map.inQueue': 'In Queue',
  'map.triangles': 'Triangles',
  'sky.sun': 'Sun',
  'sky.sunrise': 'Sunrise',
  'sky.sunset': 'Sunset',
  'sky.dayLength': 'Day Length',
  'sky.visibility': 'Visibility',
  'sky.wind': 'Wind',
  'sky.wave': 'Wave',
  'sky.time': 'Time',
  'sky.weather': 'Weather',
  'sky.strength': 'Strength',
  'sky.clockRunning': 'Clock Running',
  'sky.weatherAuto': 'Auto Weather',
  'weather.clear': 'clear',
  'weather.cloudy': 'cloudy',
  'weather.fog': 'fog',
  'weather.rain': 'rain',
  'sun.behind': 'behind you',
  'sun.day': 'day',
  'sun.night': 'night',
  'tackle.cast': 'Cast',
  'tackle.depth': 'Horizon',
  'tackle.rodTip': 'Tip',
  'tackle.fish': 'Fish',
  'tackle.tension': 'Tension',
  'tackle.waterDepth': 'Depth',
  'tackle.ready': 'ready',
  'tackle.floating': 'floating',
  'tackle.left': 'left',
  'tackle.right': 'right',
  'lure.kind': 'Kind',
  'lure.weight': 'Weight',
  'lure.diving': 'Diving',
  'lure.noLip': 'no lip',
  'lure.spoon': 'spoon',
  'lure.spinner': 'spinner',
  'lure.wobbler': 'wobbler',
  'lure.jig': 'jig',
  'line.material': 'Material',
  'line.diameter': 'Diameter',
  'line.breaking': 'Breaking',
  'line.dragTo': 'drag to',
  'line.mono': 'mono',
  'line.fluoro': 'fluoro',
  'line.braid': 'braid',
  'rod.class': 'Class',
  'rod.length': 'Length',
  'rod.test': 'Test',
  'rod.action': 'Action',
  'rod.ultralight': 'ultralight',
  'rod.light': 'light',
  'rod.medium': 'medium',
  'rod.heavy': 'heavy',
  'action.slow': 'slow',
  'action.medium': 'moderate',
  'action.fast': 'fast',
  'btn.adjust': 'Adjust',
  'btn.standard': 'Standard',
  'btn.reset': 'Reset',
  'btn.sizePlus': 'Size +',
  'btn.sizeMinus': 'Size -',
  'btn.tune': 'Tune',
  'btn.cancel': 'Cancel',
  'btn.save': 'Save',
  'outcome.landed': 'Landed',
  'outcome.lost': 'Lost',
  'outcome.break': 'Broken',
  'outcome.tackle': 'Tackle',
  'lobby.wiki': 'Encyclopedia',
  'lobby.wiki_sub': 'every fish in the game',
  'wiki.who': 'What it is',
  'wiki.where': 'Where to look',
  'wiki.how': 'What to fish with',
  'wiki.no_rod': 'not taken on rod and line',
  'wiki.when': 'When it feeds',
  'wiki.bite': 'How it bites',
  'rare.массовая': 'abundant',
  'rare.обычная': 'common',
  'rare.нечастая': 'uncommon',
  'rare.редкая': 'rare',
  'rare.очень_редкая': 'very rare',
  'rare.единичная': 'exceptional',
  'wiki.water': 'Water',
  'wiki.spawn': 'Spawning',
  'wiki.water_band': 'from {a} to {b} °C · best at {opt} °C',
  'wiki.teeth': 'cuts the line — use a leader',
  'act.дневная': 'by day',
  'act.ночная': 'at night',
  'act.сумеречная': 'at dawn and dusk',
  'act.круглосуточная': 'round the clock',
  'flow.стоячая': 'still water',
  'flow.слабое': 'slow current',
  'flow.сильное': 'strong current',
  'flow.любое': 'any current',
  'place.трава': 'weeds',
  'place.коряги': 'snags',
  'place.бровка': 'drop-off',
  'place.твёрдое_дно': 'hard bottom',
  'place.ил': 'silt',
  'place.камни': 'rocks',
  'place.открытая_вода': 'open water',
  'place.поверхность': 'surface',
  'place.перекат': 'riffle',
  'place.яма': 'deep hole',
  'school.одиночка': 'stays solitary',
  'school.малая_стая': 'in small shoals',
  'school.большая_стая': 'in dense shoals',
  'wiki.size': 'Usually {t}, up to {max}',
  'wiki.length': 'about {n} long',
  'wiki.horizon': 'Depth {a} – {b} m',
  'wiki.retrieve': 'Retrieve {a} – {b} m/s',
  'wiki.window': '{n} s to strike',
  'wiki.strike': 'Strike {n} m/s',
  'wiki.k_hard': 'sharp',
  'wiki.k_mid': 'normal',
  'wiki.k_soft': 'gentle',
  'mouth.плёночная': 'membrane lips',
  'mouth.тонкогубая': 'thin lips',
  'mouth.костистая': 'bony jaw',
  'mouth.панцирная': 'fanged jaw',
  'mouth.кожистая': 'leathery lips',
  'mouth.хрящевая': 'cartilage tube mouth',
  'wiki.thick': 'body thickness {n} cm',
  'wiki.soon': 'Not in the game yet',
  'wiki.soon_note': 'Coming as the game grows',
  'wiki.h_top': 'near the surface',
  'wiki.h_mid': 'mid-water',
  'wiki.h_deep': 'near the bottom',
  'wiki.s_slow': 'slow',
  'wiki.s_mid': 'medium',
  'wiki.s_fast': 'fast',
  'wiki.w_short': 'little time',
  'wiki.w_ok': 'enough time',
  'wiki.f_weak': 'weak',
  'wiki.f_mid': 'lively',
  'wiki.f_strong': 'strong',
  'wiki.lip_soft': 'soft mouth',
  'wiki.lip_mid': 'average mouth',
  'wiki.lip_hard': 'tough mouth',
  'wiki.stamina': 'resists up to {n} s',
  'wiki.jump_no': 'never jumps',
  'wiki.jump_rare': 'jumps at times',
  'wiki.jump_often': 'jumps often',
  'fam.карповые': 'carps',
  'fam.лососёвые': 'salmonids',
  'fam.сиговые': 'whitefish',
  'fam.окунёвые': 'perches',
  'fam.осетровые': 'sturgeons',
  'fam.сомовые': 'catfish',
  'fam.щуковые': 'pikes',
  'fam.центрарховые': 'sunfish',
  'fam.бычковые': 'gobies',
  'fam.вьюновые': 'loaches',
  'fam.корюшковые': 'smelts',
  'fam.миноговые': 'lampreys',
  'fam.прочие': 'other',
  'fam.сельдевые': 'shads',
  'fam.змееголовые': 'snakeheads',
  'fam.панцирниковые': 'gar family',
  'fam.цихловые': 'cichlids',
  'fam.харациновые': 'characins',
  'fam.ауховые': 'mandarin perches',
  'bait.мушка': 'artificial fly',
  'bait.ручейник': 'caddis larva',
  'bait.икра': 'fish roe',
  'bait.резка': 'cut bait',
  'bait.кузнечик': 'grasshopper',
  'bait.зелень': 'filamentous algae',
  'bait.лягушка': 'frog',
  'bait.фрукт': 'fruit',
  'bait.мясо': 'meat',
  'bait.хлеб': 'bread',
  'bait.червь': 'worm',
  'bait.опарыш': 'maggot',
  'bait.мотыль': 'bloodworm',
  'bait.кукуруза': 'sweetcorn',
  'bait.перловка': 'pearl barley',
  'bait.тесто': 'paste',
  'bait.горох': 'peas',
  'bait.бойл': 'boilie',
  'bait.пеллетс': 'pellets',
  'bait.ракушка': 'mussel',
  'bait.живец': 'live bait',
    'bait.рачок': 'freshwater shrimp',
  'wiki.ingame': 'In game',
  'wiki.find': 'Type a name',
  'wiki.nothing': 'Nothing found',
  'wiki.red': 'Red List',
  'wiki.red_note': 'A protected species. This fish is always released: it never enters the keepnet and cannot be sold, but the catch still gives experience and its own line in the records.',
  'lang.ru': 'RU',
  'lang.en': 'EN',
  'lang.uk': 'UK',
  'lang.es': 'ES',
  'ui.tab_gen_old': 'Generator',
  'ui.tab_map_title': 'World map: find a real water body',
  'ui.tab_map': 'Map',
  'ui.btn_rebuild_title': 'Apply all edits and rebuild the world',
  'ui.btn_rebuild': 'Rebuild world',
  'tackle.aim': 'swing',
  'tackle.flying': 'flying',
  'tackle.reeling': 'reeling',
  'tackle.taut': 'taut',
  'tackle.slack': 'slack',
  'tackle.overload': 'OVERLOAD',
  'tackle.straight': 'straight',
  'ui.sec_pond': 'Pond',
  'ui.sec_edge': 'Edge',
  'ui.sec_bank': 'Bank',
  'ui.sec_relief': 'Relief around',
  'ui.sec_ground': 'Ground',
  'tackle.drag_slipping': 'drag slipping',
  'tackle.hold': 'hold',
  'tackle.beached': 'beached',
  'tackle.strike_now': 'STRIKE',
  'ui.btn_done': 'Done',
  'ui.btn_charge': 'On click',
  'reel.mode_body': 'Mode: Body',
  'reel.mode_crank': 'Mode: Crank',
  'reel.mode_bail': 'Mode: Bail',
  'reel.mode_line': 'Mode: Line point',
  'state.world_built_already': 'world already built with these numbers',
  'ui.unit_km': 'km',
  'map.search_placeholder': 'Find water body by name...',
  'map.search_btn': 'Search',
  'map.close_title': 'Close (Esc)',
  'map.attribution': '© OpenStreetMap contributors',
  'map.zoom': 'zoom',
  'map.status_searching': 'searching...',
  'map.status_error': 'failed: {err}',
  'map.status_empty': 'nothing found',
  'map.status_found': 'found {n}',
  'map.status_network': 'no network: {err}',
  'minimap.tooltip': 'Water body map. Click to fullscreen',
  'minimap.header': 'Map',
  'minimap.close_title': 'Close · Esc',
  'minimap.zoom_in': 'Zoom In',
  'minimap.zoom_out': 'Zoom Out',
  'minimap.across': '{n} km across',
  'minimap.legend_player': 'angler',
  'minimap.legend_barrier': 'boundary, you cannot go past',
  'minimap.legend_depth': 'numbers — depth, m',
  'lure.no_lip': 'no lip',
  'tackle.drag_up_to': 'drag up to',
  'ui.status_saving': 'saving...',
  'ui.status_saved': 'saved',
  'ui.status_save_err': 'cannot save: no dev server',
  'ui.status_reset': 'reset',
  'ui.status_err': 'write error',
  'ui.status_aim_ground': 'aim at ground',
  'wind.calm': 'calm',
  'wind.light_air': 'light air',
  'wind.light_breeze': 'light breeze',
  'wind.gentle_breeze': 'gentle breeze',
  'wind.moderate_breeze': 'moderate breeze',
  'wind.fresh_breeze': 'fresh breeze',
  'wind.strong_breeze': 'strong breeze',
  'wind.near_gale': 'near gale',
  'wind.gale': 'gale',
  'sun.dawn': 'dawn',
  'sun.dusk': 'dusk',
  'sun.morning': 'morning',
  'sun.evening': 'evening',
  'sun.rel_face': 'in face',
  'sun.rel_back': 'from behind',
  'sun.rel_side': 'from side',
  'sun.rel_below': 'below horizon',
  'load.release_drag': 'RELEASE THE DRAG',
  'load.charge_over': 'TOO MUCH · THE CAST WILL LAND AT YOUR FEET',
  'load.charge_hold': 'CHARGING · RELEASE TO CAST',
  'load.aim_swing': 'SWING · MOVE THE ROD',
  'load.trophy_hold': 'FISH IN HAND · LET IT GO',
  'load.line_broken': 'LINE BROKEN · TIE A NEW ONE',
  'load.long_hang': 'LONG HANG · REEL IN',
  'load.high_above_water': 'HIGH ABOVE WATER · STEP CLOSER',
  'load.fish_nearby': 'FISH NEARBY · DROP THE BAIT',
  'load.ready': 'READY TO CAST',
  'load.landed': 'LANDED',
  'load.lost': 'LOST',
  'load.sagging': 'SLACK — REEL IN!',
  'load.biting': 'BITE — STRIKE!',
  'load.beached': 'BEACHED · REEL IN',
  'load.overload': 'OVERLOAD · RELEASE THE DRAG',
  'load.cast_dist': 'distance {m} m',
  'load.depth': 'depth {m} m',
  'load.bite_rate': 'chance {p}%',
  'reel_dial.drag': 'DRAG',
  'reel_dial.reel': 'SPEED',
  'line_dial.break': 'BREAKING',
  'line_dial.left': 'LINE LEFT',
  'line_dial.broken': 'broken',

  // ── Counting: plural forms, chosen by Intl.PluralRules (see i18n.ts) ──
  'count.fish_one': '{n} fish',
  'count.fish_other': '{n} fish',
  'count.species_one': '{n} species',
  'count.species_other': '{n} species',
  'count.records_one': '{n} record',
  'count.records_other': '{n} records',
  'count.items_one': '{n} item',
  'count.items_other': '{n} items',
  'count.waters_one': '{n} water',
  'count.waters_other': '{n} waters',

  // ── Fishing base: the lobby ───────────────────────────────────────────
  'lobby.waters': 'Waters',
  'lobby.waters_sub': 'choose where to go',
  'lobby.all_list': 'Full list',
  'lobby.world_map': 'World Map',
  'lobby.all_list_hint': 'Every country and water in one list',
  'lobby.go': 'Go fishing',
  'lobby.no_country': 'No country',
  'lobby.list_failed': 'Could not reach the server.',
  'lobby.list_failed_hint':
    'The waters are there, but the list never arrived: the game server did not answer. This is a broken connection, not an empty database.',
  'lobby.empty': 'No waters yet.',
  'lobby.empty_admin':
    'Trace a shoreline on a real map and it will join this list — and open up for everyone else too.',
  'lobby.empty_player':
    'The administrator maps them from real charts. Look in later — the first one is on its way.',
  'lobby.mirror': '{n} km² of water',
  'lobby.across': '{n} km across',
  'lobby.depth': 'up to {n} m deep',
  'lobby.no_fish': 'no fish yet',
  'lobby.mapped': 'mapped {when}',
  'lobby.base': 'Fishing base',
  'lobby.level_short': 'lvl {n}',
  'lobby.logout': 'Sign out',
  'lobby.trace_new': 'Trace a new water from the map',
  'lobby.keepnet': 'Keepnet',
  'lobby.empty': 'No waters yet.',
  'lobby.empty_admin':
    'Trace a shoreline on a real map and it will join this list — and open up for everyone else too.',
  'lobby.empty_player':
    'The administrator maps them from real charts. Look in later — the first one is on its way.',
  'lobby.mirror': '{n} km² of water',
  'lobby.across': '{n} km across',
  'lobby.depth': 'up to {n} m deep',
  'lobby.no_fish': 'no fish yet',
  'lobby.mapped': 'mapped {when}',
  'lobby.base': 'Fishing base',
  'lobby.level_short': 'lvl {n}',
  'lobby.logout': 'Sign out',
  'lobby.trace_new': 'Trace a new water from the map',
  'lobby.keepnet': 'Keepnet',
  'lobby.keepnet_empty': 'go fishing and catch something',
  'lobby.xp': 'Experience',
  'lobby.wallet': 'Wallet',
  'lobby.wallet_info': 'This is where your coins are stored. Catch fish, sell them in the shop, and buy better tackle to catch even bigger fish!',
  'lobby.xp_line': 'Level {level}. Experience to next level: {xp}.',
  'lobby.xp_info': 'Every fish you catch earns you experience. The larger and rarer the catch, the more experience you get. Level up to unlock new fishing spots!',
  'lobby.gold': 'Gold',
  'lobby.gold_info': 'Premium currency. Allows you to buy special tackle and bonuses.',
  'lobby.pack_starter_title': 'Starter Pack',
  'lobby.pack_starter_desc': '100 Gold<br>250 XP<br>1000 Coins',
  'lobby.pack_pro_title': 'Pro Pack',
  'lobby.pack_pro_desc': '300 Gold<br>750 XP<br>3000 Coins',
  'lobby.pack_master_title': 'Master Pack',
  'lobby.pack_master_desc': '1000 Gold<br>2000 XP<br>10000 Coins',
  'lobby.store_coming_soon': 'Purchases for real money will be available soon!',
  'lobby.wallet_line': '{coins} coins · level {level}, {xp} xp to the next',
  'lobby.tackle': 'Backpack',
  'lobby.in_hands': 'In hand',
  'lobby.in_bag': 'In the bag',
  'lobby.starter': 'starter',
  'lobby.worn_now': 'Equipped: {name}',
    'lobby.records': 'Player records',
  'lobby.records_none': 'nobody has set any yet',
  'lobby.mine': 'My catches',
  'lobby.open_wiki': 'open in the encyclopedia',
  'lobby.mine_none': 'the log is still empty',
  'lobby.no_server': 'server did not answer',
  'lobby.shop': 'Shop',
  'lobby.shop_sub': 'tackle, bait, gear',
  'shop.sell': 'Sell catch',
  'shop.rod': 'Rods',
  'shop.reel': 'Reels',
  'shop.line': 'Lines',
  'shop.leader': 'Leaders',
  'shop.hook': 'Hooks',
  'shop.lure': 'Lures',
  'shop.fly': 'Fly fishing',
  'shop.bait': 'Bait',
  'shop.groundbait': 'Groundbait',
  'shop.food': 'Food',
  'shop.keepnet': 'Keepnets',
  'shop.sonar': 'Sonars',
  'shop.boat': 'Boats',
  'shop.gear': 'Equipment',
  'shop.soon': 'soon',
  'lobby.shop_coins': 'In your purse: {coins} coins',
  'lobby.shop_sell': 'Sell your catch',
  'lobby.shop_buy': 'Buy tackle',
  'lobby.shop_sold': 'Fish sold: {n}',
  'lobby.shop_bought': 'Bought: {name}',
  'lobby.tours': 'Tournaments',
  'lobby.tours_sub': 'contests by time and by weight',
  'lobby.club': 'Anglers club',
  'lobby.club_sub': 'friends, ranks, trips together',
  'lobby.soon': 'soon',
  'lobby.atlas': 'Where to',
  'lobby.sheet_empty': 'Nothing yet',
  'lobby.close': 'Close',
  'lobby.cancel': 'Cancel',
  'lobby.logout_ask': 'Sign out of your account?',
  'lobby.logout_note': 'Your catch and tackle stay where they are. Coming back needs your email and password.',
  'lobby.equipped': 'worn · {slot}',
  'lobby.a_fish': 'fish',
  'lobby.account': 'Account',
  'lobby.name': 'Name',
  'lobby.name_hint': 'Other anglers see this name — in the records and out on the water.',
  'lobby.name_save': 'Save name',
  'lobby.name_done': 'You are {name} now',
  'lobby.pass_new': 'New password',
  'lobby.pass_min': 'At least 6 characters',
  'lobby.pass_again': 'Repeat password',
  'lobby.pass_again_hint': 'Once more',
  'lobby.pass_save': 'Change password',
  'err.pass_mismatch': 'Passwords do not match',
  'lobby.pass_done': 'Password changed. You will need it at the next sign-in.',
  'lobby.lang': 'Game language',
  'lobby.email_note': 'You sign in with <b>{email}</b>. Nobody but you can see it.',
  'lobby.account_hint': 'Account settings',
  'lobby.water_hint': 'Water settings',
  'lobby.fish_here': 'What fish live here',
  'lobby.fish_note':
    'An unticked species stops biting here. A new water has them all ticked, so it is ready to fish right away.',
  'lobby.save': 'Save',
  'lobby.fish_saved': 'Saved: {list}',
  'lobby.fish_none_saved': 'The water is left without fish',

  // ── Countries: key is the ISO code from the map data (see lobby.ts) ───
  'country.ua': 'Ukraine',
  'country.de': 'Germany',
  'country.it': 'Italy',
  'country.ch': 'Switzerland',
  'country.no': 'Norway',
  'country.si': 'Slovenia',
  'country.fr': 'France',
  'country.se': 'Sweden',
  'country.ee': 'Estonia',
  'country.jp': 'Japan',
  'country.es': 'Spain',
  'country.pl': 'Poland',
  'country.lt': 'Lithuania',
  'country.lv': 'Latvia',
  'country.fi': 'Finland',
  'country.cz': 'Czechia',
  'country.at': 'Austria',
  'country.hu': 'Hungary',
  'country.ro': 'Romania',
  'country.gb': 'United Kingdom',
  'country.ie': 'Ireland',
  'country.ca': 'Canada',
  'country.us': 'United States',

  'key.lmb': 'LMB',
  'key.rmb': 'RMB',

  'menu.tobase': 'Back to the base',
  'menu.tobase_sure': 'Sure? Exit to the lobby?',

  // ── Server refusals. The key travels with the text (see GameError) ────
  'err.fill_all': 'Fill in every field',
  'err.bad_credentials': 'Wrong email or password',
  'err.bad_email': 'Invalid email format',
  'err.short_password': 'Password is shorter than six characters',
  'err.keepnet_full': 'Keepnet is full: {cap} fish. Head back to base and sell your catch',
  'err.weak_password': 'Password must use Latin letters and include a digit and a capital',
  'err.user_exists': 'This user already exists',
  'err.nothing_to_sell': 'Nothing to sell',
  'err.already_sold': 'This fish is already sold',
  'err.no_such_item': 'No such item',
  'err.not_for_sale': 'This item is not for sale',
  'err.need_login': 'You need to sign in',
  'err.need_level': 'Level {n} required',
  'err.not_enough_coins': 'Not enough coins',
  'err.already_bought': 'Already bought',
  'err.wrong_slot': 'Wrong slot',
  'err.item_not_owned': 'You do not own this item',
  'err.no_water': 'No water specified',
  'err.no_fish_kinds': 'No fish species specified',
  'err.name_required': 'Enter a name',
  'err.name_short': 'Name is shorter than {n} characters',
  'err.name_long': 'Name is longer than {n} characters',
  'err.name_at': 'A name cannot contain @',
  'err.name_taken': 'That name is taken',
  'err.no_account': 'Account not found',
  'err.no_answer': 'The server did not answer',

  // ── Администрирование игроков ──
  'adm.players': "Players",
  'adm.find': "Name, email or IP",
  'adm.more': "Show more",
  'adm.total': "total: {n}",
  'adm.loading': "loading…",
  'adm.settings': "Player settings",
  'adm.admin': "admin",
  'adm.player': "player",
  'adm.banned': "banned",
  'adm.ok': "fine",
  'adm.never': "never",
  'adm.now': "online now",
  'adm.min_ago': "{n} min ago",
  'adm.hour_ago': "{n} h ago",
  'adm.day_ago': "{n} d ago",
  'adm.lvl': "lvl {n}",
  'adm.lvl_full': "Level",
  'adm.coins': "coins",
  'adm.fish': "fish",
  'adm.things': "Items",
  'adm.role': "Role",
  'adm.state': "Status",
  'adm.registered': "Registered",
  'adm.seen': "Last login",
  'adm.back': "to the list",
  'adm.give': "Give",
  'adm.rename': "Rename",
  'adm.newpass': "new password",
  'adm.setpass': "Set password",
  'adm.reason': "reason",
  'adm.ban': "Ban",
  'adm.unban': "Unban",
  'adm.make_admin': "Make admin",
  'adm.make_player': "Demote",
  'adm.last_catches': "Recent catches",
  'adm.logins': "Logins",
  'adm.failed': "failed",
  'adm.sure': "Sure?",
  'adm.yes': "Yes",

  // ── Гостевой вход ──
  'auth.or': "or",
  'auth.guest': "Play as guest",
  'lobby.logout_guest': "A guest account cannot be recovered: it has no password. Level, coins, keepnet and records will be gone for good.",
  'lobby.guest_note': "You are playing as a guest. Add an email and password — all progress stays, and you can sign in from any device.",
  'lobby.guest_email': "Email",
  'lobby.guest_save': "Make it permanent",
  'lobby.guest_done': "Done: the account is permanent now",
  'adm.guest': "guest",
  'err.guest_many': "Too many guests from this address. Try later",
  'err.not_guest': "This account is already permanent",
  'err.email_taken': "That email is already taken",

  // ── Горячие клавиши ──
  'menu.ctl_gear': "Gear",
  'menu.ctl_keepnet': "Keepnet",
  'menu.ctl_map': "Map",

  // ── Качество картинки ──
  'set.q_max': "Maximum",
  'set.q_mid': "Medium",
  'set.q_min': "Minimum",
  'set.q_off': "Off",
  'set.reflection': "Water reflection",
  'set.reflection_hint': "A second pass over the whole scene every frame. The most expensive item after render scale: on a weak machine turning it off gains more than everything else combined.",
  'set.shadows': "Shadows",
  'set.shadows_hint': "Cascaded shadows redraw the world once per cascade. One step down is one less pass over every tree.",
  'set.vegetation': "Vegetation",
  'set.vegetation_hint': "How far grass, reeds and bushes are drawn. Half the radius is a quarter of the work.",

  'set.clouds': "Clouds",
  'set.clouds_hint': "Computed per sky pixel and repeated in the reflection. Steps reduce noise detail, not the clouds themselves.",

  'load.bytes': "{done} of {total} MB · {pct} %",

  'touch.cast': "Cast",

  'touch.reel': "Reel in",

  'menu.map': "Map",

  'loader.мир': "Taking in the view",

  'load.bytes_only': "{done} MB downloaded",
  "load.file_line": "{name} · {size} MB",
  "load.world_failed": "The water could not be opened",
  "load.stalled": "Loading is taking long",
  "load.back_to_lobby": "Back to the logbook",

  'touch.lamp': "Headlamp",

  'set.hand': "Rod hand",
  'set.hand_hint': "Left — buttons on the left, gauges on the right. Right — the other way round",
  'set.hand_left': "Left",
  'set.hand_right': "Right",

  'shop.float': "Floats",
  'slot.float': "Float",
  'kit.спиннинг': "Spinning",
  'kit.удочка': "Float rod",

  'item.cast': "casts to",

  'reel_dial.depth': 'DEPTH',
  'rod.float': 'whip',
  'rod.pole': 'pole',
  'rod.bolo': 'bolognese',
  'rod.match': 'match',
  'rod.feeder': 'feeder',
  'load.engine_failed': "Could not load the game. Please reload the page.",
};
